/* 
 * AnimationOptions.js
 * Created on 28-mrt-2017
 * @author Swen Meeuwes for &ranj
 */

export default class AnimationOptions {
    constructor(delay, duration, ease, callbacks) {
        this.delay = delay || 0;
        this.duration = duration || 1000;
        this.ease = ease || createjs.Ease.none;

        if (!callbacks) {
            // No callback is provided
            this.callbacks = [];
        }
        else if (!Array.isArray(callbacks)) {
            // Only 1 callback is provided
            this.callbacks = [callbacks];
        }
        else {
            // Multiple callbacks are provided
            this.callbacks = callbacks;
        }
    };
}